export default __webpack_public_path__ + "static/media/Customer-Survey-pana.77e31be5.svg";